import Component from '../core/Component'
import { substitute } from '../utils/String'

const STATES = {
    HAS_FILES: 'has-files'
}

const MIMEDICT = {
    'image/svg+xml': 'SVG',
    'application/zip': 'ZIP',
    'application/pdf': 'PDF',
    'image/jpeg': 'JPG',
    'image/png': 'PNG',
    ' application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
    'default': 'FILE',
}

const COLORS = {
    'SVG': 'red',
    'ZIP': 'orange',
    'PDF': 'orange',
    'JPG': 'red',
    'PNG': 'red',
    'XLS': 'green',
    'XLSX': 'green',
    'DOC': 'blue',
    'DOCX': 'blue',
    'default': 'black',
}

export default class FormInputUpload extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            count: null,
            inner: null,
            fileList: null,
            itemTemplate: null,
            inputTemplate: null
        }

        this.filenames = []
        this.itemTemplate = this.ref.itemTemplate.innerHTML.trim()
        this.inputTemplate = this.ref.inputTemplate.innerHTML.trim()
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
        this.element.addEventListener('click', this.handleClick)

        this.check()
    }

    handleClick = event => {
        const element = event.target.closest('[data-action="remove"]')
        if (!element) {
            return
        }
        const itemEl = element.closest('[data-item]')
        if (!itemEl) {
            return
        }

        itemEl.parentNode.removeChild(itemEl)
        this.check()
    }

    handleChange = event => {
        this.appendUploadedInputToList(event.target)
        this.createNewInput()
        this.check()
    }

    createNewInput() {
        const div = document.createElement('div')
        div.innerHTML = substitute(this.inputTemplate, { index: this.filenames.length })

        this.ref.inner.prepend(div.firstChild)
    }

    appendUploadedInputToList(fileInput) {
        const files = [...fileInput.files]

        if (files.length < 1) {
            return
        }
        
        const filename = files[0].name
        const ext = MIMEDICT[files[0].type] ?? MIMEDICT['default']

        const buffer = document.createElement('div')
        buffer.innerHTML = substitute(this.itemTemplate, {
            index: this.filenames.length,
            href: URL.createObjectURL(files[0]),
            ext,
            color: COLORS[ext] ?? COLORS['default'],
            filename
        })
        fileInput.tabIndex = '-1'
        const itemEl = buffer.firstChild

        itemEl.prepend(fileInput)
        this.ref.fileList.appendChild(itemEl)
        this.filenames.push(filename)
    }

    check() {
        if (this.ref.fileList.children && this.ref.fileList.children.length != 0) {
            this.element.classList.add(STATES.HAS_FILES)
        } else {
            this.element.classList.remove(STATES.HAS_FILES)
        }
        this.updateCount()
    }

    updateCount() {
        this.ref.count.value = this.ref.fileList.children.length
    }
}